import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Constants from "../utils/Constants";
import { getAccessToken } from "../utils/Auth";
import Notification from "./Notification"
import { formatDate, formatText, isHidden } from "../utils/Functions";
import { Paper } from '@mui/material'
import { Box, Select, MenuItem, Typography, makeStyles } from '@material-ui/core'
import { Stack, IconButton } from "@mui/material"
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import ColumnsDialog from "./ColumnsDialog";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import DeleteDialog from "./DeleteDialog";
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import ForensicsDialog from "./ForensicsDialog";
import LoadingDialog from "./LoadingDialog";

let http_str = "https://"
let base_url = http_str.concat(Constants.apiHost, '.', Constants.domainName,'/api/v1/forensics')


const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

let headers = [
    { field: 'pk', headerName: 'ID', width: 300, hidden: true },
    { field: 'created', headerName: 'Collected on', width: 200, hidden: false },
    { field: 'hostname', headerName: 'Host', width: 'auto', hidden: false },
    { field: 'ip', headerName: 'IP Address', width: 100, hidden: false },
    { field: 'command_line', headerName: 'Command Line', width: 'auto', hidden: false },
    { field: 'sha256', headerName: 'Sha256', width: 80, hidden: false },
    { field: 'vt_str', headerName: 'VT', width: 80, hidden: false },
    { field: 'download_all', headerName: 'Download Files', width: 50, hidden: false },
    { field: 'action_process_killed', headerName: 'Process Killed', width: 50, hidden: false },
    { field: 'delete', headerName: 'Delete', width: 50, hidden: false },
]

const toastOptions = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    pauseOnHover: true,
    draggable: true
}


export default function Forensics() {
    const classes = useStyles()
    const [items, setItems] = useState([])
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedRow, setSelectedRow] = useState([null, null])
    const [columnsMode, setColumnsMode] = useState(false)
    const [editMode, setEditMode] = useState(false)
    const [deleteMode, setDeleteMode] = useState(false)
    const [limit, setLimit] = React.useState(10)
    const [pages, setPages] = useState([0])
    const [pageIndex, setPageIndex] = useState(0)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [formData, setFormData] = useState([])
    const [urls, setUrls] = useState([])
    const [isLoading, setIsLoading] = useState(false)


    const getItems = async () => {
        let url = base_url
        if (pageIndex !== 0) {
            console.log('fetch page: ' + pages[pageIndex])
            url = url + '?limit=' + limit + '&nextPageKey=' + pages[pageIndex]
        }
        else {
            console.log('fetch page: 0')
            url = url + '?limit=' + limit
        }
        const http_headers = { "Content-Type": "application/json","Authorization": await getAccessToken() }
        console.log('url: ' + url)
        await axios
            .get(url, { headers: http_headers })
            .then(res => {
                if (pageIndex === pages.length - 1) {
                    let npk = res.data['nextPageKey']
                    if (npk) {
                        let tmp_arr = pages
                        tmp_arr.push(npk)
                        setPages(tmp_arr)
                    }
                }
                const items = res.data['forensics'];
                // console.log(items);
                setItems(items)
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err.request)
                } else {
                  console.log(err)
                }
                Notification(`Error while fetching ${url}. ${err}`, 'error');
                return Promise.reject(err);
            })
    }

    const getFileUrls = async (uuid, setUrls, setSelectedItem, setOpen) => {
        setIsLoading(true)
        let url = base_url + "/" + uuid
        const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        console.log('get: ' + url + ' ' + JSON.stringify(headers))
        await axios
            .get(url, { headers: headers })
            .then(res => {
                console.log('response: ' + JSON.stringify(res.data))
                const data = res.data['forensic']
                console.log('response: ' + JSON.stringify(data))
                setFormData(data)
                setSelectedItem(data)
                setIsLoading(false)
                setOpen(true)
            })
            .catch(err => {
                console.error('Error fetching file URL:', err);
            });
        setIsLoading(false)
    }

    const deleteItem = async (uuid) => {
        let url = base_url + "/" + uuid
        const headers = { 'Content-Type': 'application/json','Authorization': await getAccessToken() }
        const toastId = toast.loading('deleting Forensics Bundle...', toastOptions)
        await axios
            .delete(url, { headers: headers })
            .then(res => {
                console.log(res.data);
                let items_filtered = items.map((x) => x)
                items_filtered = items_filtered.filter(i => i.pk !== uuid)
                setItems(items_filtered)
                toast.update(toastId, {render: `${res.data['msg']}`, type: "success", isLoading: false, autoClose: 2000})
            })
            .catch(err => {
                if (err.response) {
                  console.log('bad response from server: ' + err.response)
                } else if (err.request) {
                  console.log('no response from server: ' + err)
                } else {
                  console.log(err)
                }
                toast.update(toastId, {render: `Error deleting: ${err}`, type: "error", isLoading: false, closeButton: true})
                return Promise.reject(err);
            })
    }

    // PrefetchSelectedRow will fetch list details every row you click
    // It should make loading the edit screen faster, but it might add a lot more API calls
    const prefetchSelectedRow = (uuid) => {
        // console.log("selected row = " + selectedRow)
        if (selectedRow === uuid) {
            // deselect a row if it's already selected
            setSelectedRow(null)
        }
        else {
            setSelectedRow(uuid)
            let item = getItemByPk('items', uuid)
            setSelectedItem(item)
            setFormData(item)
            // getDetail(uuid)
        }
    }

    function getItemByPk(table, pk) {
        // might have over-engineered this, so far only needs items case
        switch (table) {
            case 'items':
                let top_level_result = items.find(i => i.pk === pk)
                if (top_level_result === undefined) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].hasOwnProperty('children')) {
                            // for (let j = 0; j < items[i])
                            let second_level_result = items[i]['children'].find(i => i.pk === pk)
                            if (second_level_result !== undefined) {
                                return second_level_result
                            }
                        }
                    }
                }
                return items.find(i => i.pk === pk)
            default:
                return null
        }
    }

    function isDownloadable(param) {
        if (param !== undefined && param !== '') {
            return true
        }
        else {
            return false
        }
    }

    function getProcessKilledIcon(killed) {
        if (killed === true) {
            return (
                <CheckBoxOutlinedIcon color="success"></CheckBoxOutlinedIcon>
            )
        }
        else {
            return (
                <CheckBoxOutlineBlankOutlinedIcon color={"disabled"}></CheckBoxOutlineBlankOutlinedIcon>
            )
        }
    }

    const handleOpenColumns = () => {
        setColumnsMode(true);
    };

    const handleCloseColumns = () => {
        setColumnsMode(false);
    };

    const handleOpenEdit = (e, uuid) => {
        setSelectedRow(uuid)
        console.log("open " + selectedRow)
        console.log('uuid = ' + uuid)
        getFileUrls(uuid, setUrls, setSelectedItem, setEditMode)
        // getDetail(base_url, 'forensic', uuid, setSelectedItem, setEditMode)
        setFormData((prevFormData) => ({...selectedItem, ['pk']: uuid}))
    };

    const handleCloseEdit = () => {
        setEditMode(false);
    };

    const handleOpenDelete = (e, uuid) => {
        // stopPropagation seems to block selecting and editing a row in 1 click, so remove it if it doesn't cause any other issues
        //e.stopPropagation()
        setSelectedRow(uuid)
        setDeleteMode(true);
        console.log("delete " + selectedRow)
    };

    const handleDelete = (uuid) => {
        deleteItem(uuid)
        setDeleteMode(false);
    };

    const handleCloseDelete = () => {
        setDeleteMode(false);
    };

    const handleLimit = (event) => {
        setLimit(event.target.value);
        setPages([0])
        setPageIndex(0)
    };

    const handlePreviousPage = () => {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1)
        }
    }

    const handleNextPage = () => {
        if (pageIndex < pages.length - 1) {
            setPageIndex(pageIndex + 1)
        }
    }

    const toggleColumn = (event) => {
        for (let i = 0; i < headers.length; i++) {
            if (headers[i]['field'] === event.target.id) {
                headers[i]['hidden'] = !headers[i]['hidden']
            }
        }
        //  ugly but since the checkboxes aren't tied to state, they are tied to column definitions, they don't update
        forceUpdate()
    };

    useEffect(() => {
        getItems()
    }, []);

    return (
        <div className={classes.outer_div} style={{padding: '20px'}}>
            <Paper className={classes.card} variant="outlined" style={{padding: '15px'}}>
                <Stack direction={"row"} justifyContent={"space-between"}>
                    <Typography variant="h4" >Forensic Collections</Typography>
                    <Box>
                        <ViewWeekOutlinedIcon className={classes.spaced} color={"primary"}
                                              onClick={() => handleOpenColumns()}/>
                    </Box>
                </Stack>
                {/* TABLE */}
                <table className={classes.tableComponent} style={{width: 100 + "%"}}>
                    <thead>
                    <tr key={"1"} className={classes.tableComponent}>
                        {headers.map(header => (
                            <th width={header.width}
                                className={header.hidden === true ? classes.hide : ''}>{header.headerName}</th>
                        ))}
                    </tr>
                    </thead>
                    <tbody className={classes.tableComponent}>
                    {items.map(val =>
                        <tr key={val.pk} onClick={() => prefetchSelectedRow(val.pk)}
                            bgcolor={selectedRow === val.pk ? '#242c42' : '#222222'}
                            className={classes.tableComponent}>
                            <td className={isHidden('pk', headers) ? classes.hide : classes.tableCell}>{val.pk}</td>
                            <td className={isHidden('created', headers) ? classes.hide : classes.tableCell}>{formatDate(val.created)}</td>
                            <td className={isHidden('hostname', headers) ? classes.hide : classes.tableCell}>{val.hostname}</td>
                            <td className={isHidden('ip', headers) ? classes.hide : classes.tableCell}>{val.ip}</td>
                            <td className={isHidden('command_line', headers) ? classes.hide : classes.tableCell}>{formatText(val.command_line, 100)}</td>
                            <td className={isHidden('sha256', headers) ? classes.hide : classes.tableCell}>{formatText(val.sha256, 6)}</td>
                            <td className={isHidden('vt_str', headers) ? classes.hide : classes.tableCell}>{val.vt_str}</td>
                            <td align="center"
                                className={isHidden('download_all', headers) ? classes.hide : classes.clickableTableCell}>
                                <CloudDownloadOutlinedIcon color={isDownloadable(val.pk) ? "success" : "disabled"}
                                                           onClick={(e) => handleOpenEdit(e, val.pk)}/>
                            </td>
                            <td align="center"
                                className={isHidden('action_process_killed', headers) ? classes.hide : classes.clickableTableCell}>
                                {getProcessKilledIcon(val.action_process_killed)}
                            </td>
                            <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                                <BackspaceOutlinedIcon color="error"
                                                       onClick={(e) => handleOpenDelete(e, val.pk)}/>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                <Paper className={classes.itemBar} elevation={1}>
                    <Stack className={classes.pageBar}
                           elevation={0}
                           direction="row"
                           alignItems="center"
                           sx={{width: 1, height: "5vh" }} >
                            <IconButton onClick={() => getItems()}><RefreshOutlinedIcon className={classes.spaced} /></IconButton>
                            <Typography className={classes.spaced}>Rows per page:</Typography>
                            <Select
                                classes={{ root: classes.whiteColor, icon: classes.whiteColor }}
                                labelId="fetch-limit-select"
                                id="fetch-limit-select"
                                name="fetch-limit-select"
                                value={limit}
                                label="Limit"
                                onChange={handleLimit}
                            >
                              <MenuItem value={10}>10</MenuItem>
                              <MenuItem value={25}>25</MenuItem>
                              <MenuItem value={50}>50</MenuItem>
                            </Select>
                            <IconButton disabled={pageIndex === 0} onClick={() => handlePreviousPage()}><ChevronLeftOutlinedIcon /></IconButton>
                            <Typography variant={'h6'}>{pageIndex + 1}</Typography>
                            <IconButton disabled={pageIndex >= pages.length - 1} onClick={() => handleNextPage()}><ChevronRightOutlinedIcon /></IconButton>
                    </Stack>
                </Paper>

                {/* DIALOGS */}
                {/* COLUMNS DIALOG */}
                <ColumnsDialog
                    variant={"outlined"}
                    open={columnsMode}
                    onClose={handleCloseColumns}
                    onChange={toggleColumn}
                    headers={headers}
                />

                {/* EDIT DIALOG */}
                <ForensicsDialog
                    open={editMode}
                    onClose={handleCloseEdit}
                    formData={formData}
                    urls={urls}
                />

                {/* LOADING DIALOG */}
                <LoadingDialog
                    open={isLoading}
                    setIsLoading={setIsLoading}
                />

                {/* DELETE DIALOG */}
                <DeleteDialog
                    open={deleteMode}
                    onClose={handleCloseDelete}
                    onDelete={handleDelete}
                    formData={''}
                    setFormData={''}
                    type={'forensics'}
                    row={selectedRow}
                    item={selectedItem}
                />
            </Paper>
        </div>
    )
}